module.exports = __webpack_public_path__ + "media/images/figure/ssi-ec1671cdb021cf9455804b6b64eec318.gif";